import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  return (
    <div className="py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            <span className="text-white">About </span>
            <span className="text-electricBlue">Imagination Labs</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Making powerful technology accessible to small businesses. Keeping curiosity at the heart of what we do.
          </p>
        </motion.div>
        
        <div className="max-w-3xl mx-auto space-y-10 text-lg text-gray-300">
          <section><h2 className="text-2xl font-bold text-white mb-4">Big ideas shouldn’t need a big company budget.</h2><p>Websites, automation, AI, and custom software have often felt out of reach for small businesses. Imagination Labs exists to lower that barrier with practical solutions built around real needs and realistic budgets.</p></section>
          <section><h2 className="text-2xl font-bold text-white mb-4">Your business comes first.</h2><p>We work with small businesses across industries. The starting point is always the same: understand how you work, find what’s getting in the way, and choose a useful next step. We explain the options in plain language so you can decide what makes sense.</p></section>
          <section><h2 className="text-2xl font-bold text-white mb-4">And there’s always room to explore.</h2><p>AI and technology research are our side passion. The Lab gives us a place to experiment, build prototypes, and follow questions just because they’re interesting. That curiosity is part of who we are.</p></section>
        </div>
      </div>
    </div>
  );
};

export default About; 